import React from 'react';
import { Button } from 'primereact/button';
import GoogleCalendarIntegration from './GoogleCalendarIntegration';

const CalendarHeader = ({
    onNewEvent,
    onNewVisit,
    googleCalendarEnabled,
    setGoogleCalendarEnabled,
    currentUser,
    showToast,
    fetchEvents,
    disconnectDialog,
    setDisconnectDialog
}) => {
    return (
        <div className="page-header">
            <div className="create-event space-x-4">
                <Button
                    label="New Event"
                    className="p-button-rounded p-button-primary"
                    onClick={onNewEvent}
                />

                <Button
                    label="Visit"
                    className="p-button-rounded p-button-primary"
                    onClick={onNewVisit}
                />
            </div>
            <div>
                <GoogleCalendarIntegration
                    googleCalendarEnabled={googleCalendarEnabled}
                    setGoogleCalendarEnabled={setGoogleCalendarEnabled}
                    currentUser={currentUser}
                    showToast={showToast}
                    fetchEvents={fetchEvents}
                    disconnectDialog={disconnectDialog}
                    setDisconnectDialog={setDisconnectDialog}
                />
            </div>
        </div>
    );
};

export default CalendarHeader;